


































































































































































































































































































































































































































































































































































































































































































import {
  Component,
  Vue,
  Config,
  TModelBase,
  Model,
  Watch,
  Prop,
} from "@/common";
@Component({})
export default class OrderEdit extends TModelBase {
  switchShowTModel(val) {
    if (val === false) {
      this.resetForm("headForm");
      this.head.ORDER_TYPE = null;
      this.head.GUID = ""; 
    } else {
      if (this.propkey !== "") {
        this.dataLoading = true;
        this.$http
          .post("Biz/Order/GetRecord", {
            GUID: this.propkey,
          })
          .then((res) => {
            this.dataLoading = false;
            if (res.data.status === 0) {
              Object.assign(this.head, res.data.head);
            } else {
              this.$message.warning(res.data.msg || "操作失败");
            }
          });
      }
      else{this.getY_NO();}
    }
  }

  @Prop({})
  private contrs!: Array<any>;

  @Prop({})
  private carname!: Array<any>;

  @Prop({})
  private shcarname!: Array<any>;

  @Prop({})
  private toadress!: Array<any>;

  @Prop({})
  private propkey!: String;

  head = {
    A_WEIGHT: null,
    CAR_NO: null,
    CAR_NAME: null,
    CAR_TEL: null,
    CREATE_DATE: null,
    CREATE_USER: null,
    CUSTOM_NAME: null,
    DC_FEE: null,
    F_WEIGHT: null,
    FROM_DZ: null,
    GOODS_NAME: null,
    GUID: null,
    LF: null,
    NOTE: null,
    ORDER_TYPE: null,
    OTHER_FEE: null,
    P_WEIGHT: null,
    PRICE: null,
    QTY: null,
    SH_FEE: null,
    SH_NAME: null,
    SIZE: null,
    T_WEIGHT: null,
    TH_DATE: null,
    TH_FEE: null,
    DD_STAGE: null,
    TO_DZ: null,
    TOTAL_FEE: null,
    TP: null,
    TP_SIZE: null,
    TRANS: null,
    TY_NAME: null,
    UNIT: null,
    WEIGHT: null,
    Y_FEE: null,
    Y_NO: null,
    ZX_SIZE: null,
    CONTR_NO: null,
    SIGN_DATE: null,
    SHCAR_NAME: null,
    SHCAR_TEL: null,
    TO_TEL: null,
    FROM_TEL: null,
    MAIL_TIME1: null,
    MAIL_TIME2: null,
    MAIL_TIME3: null,
    KF_NAME: null,
    KF_TEL: null,
    YJSH_DATE: null,
    GOODS_VALUE: null,
    PAY_TYPE: null,
    FLIGHT: null,
    TH_ADRESS: null,
    SEARCH_TEL: null,
    OKPROCESS: null,
    PACKAGE: null,
    SignBack: null,
  };

  dataLoading = false;

  saveMask = false;

  rules = {
    CONTR_NO: [{ required: true, message: "请选择合同", trigger: "blur" }],
    Y_NO: [{ required: true, message: "请输入运单号", trigger: "blur" }],
  };

  getY_NO() {
    this.$http
      .get("Biz/Order/GetY_NO", {
        params: { carname: this.head.CAR_NAME },
      })
      .then((res) => {
        this.head.Y_NO = res.data.y_no;
      });
  }

  cusChange() {
    this.$http
      .get("Biz/Order/GetTel", {
        params: { carname: this.head.CAR_NAME },
      })
      .then((res) => {
        this.head.CAR_TEL = res.data.addr;
      });
  }

  cusToDZChange() {
    this.$http
      .get("Biz/Order/GetToDZ", {
        params: { customname: this.head.CUSTOM_NAME },
      })
      .then((res) => {
        this.head.SH_NAME = res.data.name;
        this.head.TO_TEL = res.data.tel;
        this.head.TO_DZ = res.data.address;
      });
  }

  cusSHChange() {
    this.$http
      .get("Biz/Order/GetSHTel", {
        params: { shcarname: this.head.SHCAR_NAME },
      })
      .then((res) => {
        this.head.SHCAR_TEL = res.data.addr;
      });
  }

  Save() {
    this.isFormValid("headForm", (valid) => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Biz/Order/Save", {
            order: this.head,
          })
          .then((res) => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.$message.success("保存成功");
              this.showTModel = false;
              this.$emit("on-ok");
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg || "保存失败");
            }
          })
          .catch((err) => {
            this.saveMask = false;
            this.$message.warning(err);
          });
      }
    });
  }

  mounted() {}
}
